import React, { Component } from 'react';
import { Button, Dialog } from '@betareader/design-system';
import {
  withRouter, Link
} from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import styled from 'styled-components';


import {
  deleteVersion,
  duplicateVersion
} from '../../modules/book';
import VersionSelector from '../menu/versionSelector';
import DownloadVersion from './downloadVersion';
import PartsList from '../menu/partsList';
import { authUtil } from '../../utils';

const Wrapper = styled.div`
  flex: 1;
  max-width: 768px;
  padding: 0 1em 0 1em;
`;

export class VersionOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copyComments: false,
      migrateReaders: false
    };
  }

  addNewVersion = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const { idToken, currentBook } = this.props;
    this.props.createNewVersion(idToken, currentBook._id, [], (newBookVersion) => {
      this.props.history.replace(`/books/${currentBook._id}/content/v${newBookVersion.content.length}`)
    });
  }

  prompt = (prompt) => {
    this.setState({
      prompt
    });
  }

  confirmDelete = async () => {
    const { currentBook, currentContentVersion } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    this.props.deleteVersion(idToken, currentBook._id, currentContentVersion._id, () => {
      this.setState({
        prompt: false
      });
      this.props.history.replace(`/books/${currentBook._id}/content/v${currentBook.content.length}`)
    });
  }

  confirmDuplicate = async () => {
    const { currentBook, currentContentVersion } = this.props;
    const { copyComments, migrateReaders } = this.state;
    this.setState({
      isDuplicating: true
    });
    const idToken = await authUtil.getFreshIdToken();
    this.props.duplicateVersion(idToken, {
      bookId: currentBook._id,
      contentVersionId: currentContentVersion._id,
      copyComments,
      migrateReaders,
      callback: (updatedBook) => {
        this.setState({
          prompt: false,
          isDuplicating: false
        });
        this.props.history.replace(`/books/${currentBook._id}/content/v${updatedBook.content[updatedBook.content.length - 1].versionNumber}`)
      }
    });
  }

  handleCopyCommentsChange = (event) => {
    this.setState({
      copyComments: event.target.checked
    });
  }

  handleMigrateReadersChange = (event) => {
    this.setState({
      migrateReaders: event.target.checked
    });
  }

  render() {
    const {
      t, currentContentVersion, currentBook
    } = this.props;
    const {
      prompt, copyComments, migrateReaders, isDuplicating
    } = this.state;
    if (!currentContentVersion) {
      return null;
    }
    const parts = currentContentVersion.parts || [];
    const chapters = parts.filter(part => part.kind === 'Chapter');
    const surveys = parts.filter(part => part.kind === 'Survey');
    const canDeleteVersion = parts.length === 0 && currentBook.content.length > 1;
    const canDuplicateVersion = parts.length > 0;
    return (
      <Wrapper>
        <header>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 'var(--br-space-2)' }}>
            <h2 style={{ flex: 1, margin: 0 }}>
              {t('Version')}: <VersionSelector key='version-selector' />
            </h2>
            <DownloadVersion
              compact
              bookId={currentBook._id}
              content={[currentContentVersion]}
            />
            <Button variant='secondary' size='small'
              disabled={!canDuplicateVersion}
              onClick={() => this.prompt('duplicate')}>
              {t('Duplicate')}
            </Button>
          </div>
          <p style={{ color: 'var(--br-muted)' }}>
            {t('ChapterCount', { count: chapters.length })}, {t('SurveyCount', { count: surveys.length })}
          </p>
        </header>
        <span>
          <Link to={`/books/${currentBook._id}/content/v${currentContentVersion.versionNumber}/new-chapter`}>{t('NewChapter')}</Link>
          {' '}
          <Link to={`/books/${currentBook._id}/content/v${currentContentVersion.versionNumber}/new-survey`}>{t('NewSurvey')}</Link>
        </span>
        <PartsList />
        <hr />
        {currentBook.content.length > 1 && (
          <Button
            variant='danger'
            disabled={!canDeleteVersion}
            onClick={() => this.prompt('delete')}
          >{t('Delete')}</Button>
        )}
        <Dialog open={prompt === 'delete'} title={t('AreYouSure?')}
          onClose={() => this.prompt(false)}
          actions={<>
            <Button variant='secondary' onClick={() => this.prompt(false)}>{t('Cancel')}</Button>
            <Button variant='danger' onClick={this.confirmDelete}>{t('Delete')}</Button>
          </>}>
          <p>{t('ThisCannotBeUndone')}</p>
        </Dialog>
        <Dialog open={prompt === 'duplicate'} title={t('Duplicate')}
          onClose={() => this.prompt(false)}
          actions={<>
            <Button variant='secondary' onClick={() => this.prompt(false)} disabled={isDuplicating}>{t('Cancel')}</Button>
            <Button onClick={this.confirmDuplicate} disabled={isDuplicating}
              aria-busy={isDuplicating}>{t('Duplicate')}</Button>
          </>}>
          <p>{t('DuplicateVersionInfo')}</p>
          <label style={{ display: 'block', marginBottom: 'var(--br-space-2)' }}>
            <input type='checkbox' checked={copyComments} onChange={this.handleCopyCommentsChange} />
            {' '}{t('CopyComments')}
          </label>
          <label style={{ display: 'block' }}>
            <input type='checkbox' checked={migrateReaders} onChange={this.handleMigrateReadersChange} />
            {' '}{t('MigrateReaders')}
          </label>
        </Dialog>
      </Wrapper>
    );
  }
}


// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  currentBook: state.book.currentBook,
  currentContentVersion: state.book.currentContentVersion
});

const mapDispatchToProps = dispatch => bindActionCreators({
  deleteVersion,
  duplicateVersion
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(VersionOverview)));
